import { Component, OnInit, NgZone, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { DataElement } from '../shared/dataElement';
import { TitleIIIDataEntryService } from './titleIIIDataEntry.service';
import { ClaimService } from '../shared/claim.service';
import { OALegalCasesSection } from './OALegalCasesSection';
import { CommonService } from '../shared/common.service';
import { ToastrService } from '../shared/toastr.service';
import { QuestionStatusEnum } from '../shared/dataElement';
import { ValidationService } from '../shared/validation.service';
import { TitleIIISectionComponent } from './title-iii-section.component';

@Component({
  templateUrl: 'titleIIIOALegalCases.component.html',
})

export class TitleIIIOALegalCasesComponent extends TitleIIISectionComponent<OALegalCasesSection> implements OnInit, OnDestroy {

  _sectionModel: OALegalCasesSection;
  _uploadModels: Array<OALegalCasesSection>;
  _batchIds: Array<string>;
  serviceArr: Array<DataElement>;
  typeArr: Array<DataElement>;
  unsavedChanges: boolean = false;
  questionStatusEnum = QuestionStatusEnum;

  constructor(public zone: NgZone,
    public route: ActivatedRoute,
    public router: Router,
    public _titleService: Title,
    public _service: TitleIIIDataEntryService,
    public _claimService: ClaimService,
    public _commonService: CommonService,
    public _validation: ValidationService,
    public toastr: ToastrService
  ) {
    super(new OALegalCasesSection(), _commonService, _validation, router, _claimService, _service);
   }

  ngOnInit(): void {
    this._titleService.setTitle('Older Adults - Legal Assistance - Levels of Service and Types of Cases - Data Submissions - ACL OAAPS');
    this._sectionModel = new OALegalCasesSection();
    this.getoalegalcasesbyffyandstate();
  }

  ngOnDestroy(): void {
    super.destroy();
  }

  save(callback: () => void = () => null): void {
    this.unsavedChanges = false;
    // TODO Move this logic into Controller for security
    this._sectionModel.state = this._claimService.currentOrg;
    this._sectionModel.fiscalYear = this._claimService.currentYear;
    super.registerSubscription(this._service.saveoalegalcases(this._sectionModel)
      .subscribe(data => this.zone.run(() => {
        this._sectionModel = data;
        this.initArrays();
      }),
        (error)=> console.log(error),
        () => {
          //finalize(callback);

          this.toastr.success('Saved!');
          callback();
        }
      ));
  }

  saveAndNext(): void {
    this.unsavedChanges = false;
    const navAction = () => this.router.navigate(['/data-submissions/titleIIITransportation']);
    if (!this._claimService.isViewOnly && 
      this._commonService.shouldSave(this._sectionModel, this._claimService.isAAAEnabledStateUser(), this._service.aaaStateEditMode)) {
      this.save(navAction);
    } else {
      navAction();
    }
  }

  next(): void {
        this.router.navigate(['/data-submissions/titleIIITransportation']);
  }

  getoalegalcasesbyffyandstate(): void {
    super.registerSubscription(this._service.get<OALegalCasesSection[]>(this._claimService,
      this._service._getoalegalcasesbyffyandstate, this.resolveSectionName())
      .subscribe(data => this.zone.run(() => {
        if (data.length > 0) {
          // Adding this so if the filter returns nothing, _sectionModel won't be undefined;
          let tempSectionModel: OALegalCasesSection = new OALegalCasesSection();
          tempSectionModel = data.filter(element => element.batchId === '00000000-0000-0000-0000-000000000000')[0];
          if (tempSectionModel) {
            this._sectionModel = tempSectionModel;
            // initialize arrays for summing
            this.initArrays();
          }
          this._uploadModels = data.filter(element => element.batchId !== '00000000-0000-0000-0000-000000000000');
          if (this._uploadModels != null && this._uploadModels.length > 0) {
            this._batchIds = this._uploadModels.map<string>(e => e.batchId);
            // initialize arrays for summing
            this.initArrays();
          }
          this.formatAllNumbersAlreadySaved();
          super.processSectionStatus();
        } else {
          this.initArrays();
        }

      })));
  }

  initArrays(): void {
    this.serviceArr = [this._sectionModel.advice,
    this._sectionModel.limited,
    this._sectionModel.rep];

    this.typeArr = [this._sectionModel.income,
    this._sectionModel.healthCare,
    this._sectionModel.longTerm,
    this._sectionModel.nutrition,
    this._sectionModel.housing,
    this._sectionModel.utilities,
    this._sectionModel.abuseNeglect,
    this._sectionModel.defenseGuardianship,
    this._sectionModel.ageDiscrimination,
    this._sectionModel.other];
  }

  updateTotal(totalsArray: Array<DataElement>): string {
    let total: number = 0;

    for (let i = 0; i < totalsArray.length; i++) {
      // if not null, remove commas
      if (totalsArray[i].elementValue) {
        totalsArray[i].elementValue = totalsArray[i].elementValue.replace(/,/g, '');
      }
      // if is a number, sum it
      if (!isNaN(parseInt(totalsArray[i].elementValue))) {
        total += parseInt(totalsArray[i].elementValue);
      }
      // replace commas when done adding
      totalsArray[i].elementValue = this.addComma(totalsArray[i].elementValue);
    }

    // add comma and return
    return this.addComma(total.toString());
  }

  formatAllNumbersAlreadySaved(): void {
    this._sectionModel.openCases.elementValue = this.addComma(this._sectionModel.openCases.elementValue);
    this._sectionModel.closedCases.elementValue = this.addComma(this._sectionModel.closedCases.elementValue);

    this._sectionModel.advice.elementValue = this.addComma(this._sectionModel.advice.elementValue);
    this._sectionModel.limited.elementValue = this.addComma(this._sectionModel.limited.elementValue);
    this._sectionModel.rep.elementValue = this.addComma(this._sectionModel.rep.elementValue);
    this._sectionModel.serviceClosed.elementValue = this.addComma(this._sectionModel.serviceClosed.elementValue);

    this._sectionModel.income.elementValue = this.addComma(this._sectionModel.income.elementValue);
    this._sectionModel.healthCare.elementValue = this.addComma(this._sectionModel.healthCare.elementValue);
    this._sectionModel.longTerm.elementValue = this.addComma(this._sectionModel.longTerm.elementValue);
    this._sectionModel.nutrition.elementValue = this.addComma(this._sectionModel.nutrition.elementValue);
    this._sectionModel.housing.elementValue = this.addComma(this._sectionModel.housing.elementValue);
    this._sectionModel.utilities.elementValue = this.addComma(this._sectionModel.utilities.elementValue);
    this._sectionModel.abuseNeglect.elementValue = this.addComma(this._sectionModel.abuseNeglect.elementValue);
    this._sectionModel.defenseGuardianship.elementValue = this.addComma(this._sectionModel.defenseGuardianship.elementValue);
    this._sectionModel.ageDiscrimination.elementValue = this.addComma(this._sectionModel.ageDiscrimination.elementValue);
    this._sectionModel.other.elementValue = this.addComma(this._sectionModel.other.elementValue);
    this._sectionModel.typeClosed.elementValue = this.addComma(this._sectionModel.typeClosed.elementValue);
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (!this.unsavedChanges || sessionStorage.getItem('sessionExpiredRedirect')) {
      this._commonService.oaLockedNav = false;
      return true;
    } else {
      this._commonService.oaLockedNav = true;
      return false;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  showMsg($event) {
    if (!this.canDeactivate()) {
      $event.returnValue = `You have unsaved changes. Press OK to proceed without saving these changes,
or press Cancel to go back and save these changes.`;
    }
  }

}
